import React from 'react';

import NotificationStore from '../../flux/stores/NotificationStore.js';
import Notification from './Notification';

function getStoreState () {
    return {
        notifications: NotificationStore.getNotifications()
    };
}

class Notifications extends React.Component {
    constructor (props) {
        super(props)
        this.state = getStoreState();
    }

    componentWillMount () {
        NotificationStore.addChangeListener(this.onChange);
    }

    componentWillUnmount () {
        NotificationStore.removeChangeListener(this.onChange);
    }

    onChange () {
        this.setState(getStoreState());
    }

    render () {
        var size = this.state.notifications.length;
        if (!size) return <span style={{display: 'none'}}/>;
        var count = (size > 1) ?
            (<div className="notification-count">
                <i className="fa fa-plus"/> {size - 1} more
            </div>) :
            <span style={{display: 'none'}}/>;
        return (
            <div id="notify">
                {count}
                <Notification notification={this.state.notifications[0]}/>
            </div>
        );
    }
}

export default Notifications;
